// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Details_disabled__1-jJm","body":"Details_body__3KOjX","desc":"Details_desc__1Yx-P","date":"Details_date__1LNj8"};